import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, ExternalLink, ChevronRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { elezioni2025, candidatiRegionali } from '../data/siteData';

export const ElezioniRegionali = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="elezioni-regionali-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-[#002060] to-[#003380] py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Torna alla home
          </Link>
          
          <div className="text-center">
            <span className="text-xs uppercase tracking-widest font-semibold text-[#5CB9E5] mb-4 block">
              Elezioni 2025
            </span>
            <h1 className="font-serif text-4xl md:text-6xl font-bold text-white mb-4">
              Candidati Regionali
            </h1>
            <p className="text-2xl text-[#FFD700] font-medium mb-2">
              Valle d'Aosta 2025
            </p>
            <p className="text-white/80 mb-2">
              Lista Unica INSIEME - ENSEMBLE
            </p>
            <p className="text-[#5CB9E5]">
              {elezioni2025.regionali.coalition}
            </p>
          </div>
        </div>
      </section>

      {/* Coalition Banner */}
      <section className="bg-[#FFD700] py-6">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-center md:text-left">
              <p className="font-semibold text-[#002060]">
                Il centro moderato della coalizione di centrodestra
              </p>
              <p className="text-[#002060]/80 text-sm">
                Forza Italia e La Renaissance Valdôtaine insieme per il cambiamento
              </p>
            </div>
            <Link to="/programma-regionale">
              <Button className="btn-primary px-6 py-2 rounded-lg flex items-center gap-2">
                Scopri il Programma
                <ChevronRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Lista Candidati */}
      <section className="py-16 bg-white" data-testid="candidati-regionali-list">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center mb-12">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#002060] mb-4">
              Lista dei Candidati
            </h2>
            <p className="text-slate-600">
              {candidatiRegionali.length} candidati al Consiglio Regionale della Valle d'Aosta
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {candidatiRegionali.map((candidato, index) => (
              <div 
                key={index}
                className="bg-[#F4F6F8] rounded-lg p-5 hover:shadow-md transition-shadow border-l-4 border-[#FFD700]"
                data-testid={`candidato-regionale-card-${index}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1">
                    <span className="text-xs text-[#FFD700] font-semibold">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <h3 className="font-semibold text-[#002060] mt-1">
                      {candidato.nome}
                    </h3>
                  </div>
                </div>
                <div className="flex gap-4 mt-4 text-sm">
                  <a 
                    href={candidato.cv}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#002060] hover:text-[#5CB9E5] transition-colors flex items-center gap-1"
                  >
                    <FileText className="w-3 h-3" />
                    CV
                  </a>
                  <a 
                    href={candidato.certificato}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#002060] hover:text-[#5CB9E5] transition-colors flex items-center gap-1"
                  >
                    <FileText className="w-3 h-3" />
                    Certificato
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Programma CTA */}
      <section className="py-16 bg-[#002060]">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-serif text-3xl font-bold text-white mb-4">
            Il nostro programma per la Valle d'Aosta
          </h2>
          <p className="text-white/80 mb-8">
            15 punti programmatici per il rilancio della regione
          </p>
          <Link to="/programma-regionale">
            <Button className="btn-gold px-8 py-3 rounded-lg font-semibold flex items-center gap-2 mx-auto">
              <FileText className="w-5 h-5" />
              Leggi il Programma Completo
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};
